import React from 'react';
import PropTypes from 'prop-types';
import Headline from '@components/atoms/headline/headline';
import { useTranslations } from 'next-intl';
import { ArrowRight } from '@components/icons/arrow/arrow';
import Link from 'next/link';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import Image from '@components/atoms/image/image';
import stripHtmlTags from '@helper/stripHtmlTags';
import StyledEventTeaserListItem from './eventTeaserListItem.style';
import EventDateA11y from '../event-date-a11y/eventDateA11y';

const imageSizes = [
  {
    condition: 'min-width: 980px',
    width: '30vw'
  },
  {
    condition: 'min-width: 450px',
    width: '45vw'
  },
  {
    width: '100vw'
  }
];

const EventTeaserListItem = ({ title, copy, uri, image, hours, startTime }) => {
  const t = useTranslations();
  const [datePart] = startTime.split(' ');
  const [, m, d] = datePart.split('-');

  const startDate = {
    d: `${d}`,
    m: `${m}`
  };

  return (
    <StyledEventTeaserListItem noImage={!image?.src}>
      <div className="card">
        {image && image.src && (
          <div className="card__image">
            <Image {...image} sizes={imageSizes} />
          </div>
        )}
        {startDate && (
          <div className="card__date">
            <EventDateA11y startDate={startDate} />
          </div>
        )}
        <div className="card__content">
          <div className="card__text">
            {hours && <span className="card__time">{hours}</span>}
            {uri && (
              <Link href={uri} aria-label={title}>
                {title && (
                  <Headline className="card__headline" tag="span">
                    {title.length > 110 ? `${title.substring(0, 110)}...` : title}
                  </Headline>
                )}
                <span className="card__stretched-link" />
              </Link>
            )}
            <MixedCopy
              className="card__copy"
              fullWidth
              html={
                stripHtmlTags(copy).length > 140
                  ? `${stripHtmlTags(copy).substring(0, 140)}...`
                  : stripHtmlTags(copy)
              }
            />
          </div>
          <div className="card__arrow">
            <ArrowRight role="img" ariaLabel={`${t('openPage')} icon`} />
          </div>
        </div>
      </div>
    </StyledEventTeaserListItem>
  );
};

EventTeaserListItem.propTypes = {
  title: PropTypes.string.isRequired,
  copy: PropTypes.string,
  uri: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  hours: PropTypes.string,
  startTime: PropTypes.string.isRequired
};

export default EventTeaserListItem;
